import styled from 'styled-components'
import content from '../../../styles/_objects/content'
import { darkGrey } from 'styles/settings/colors'
import { txt12OpenSans } from 'styles/settings/types'

export const Container = styled.div`
  ${content};
`
export const Text = styled.p`
  ${txt12OpenSans} white-space: normal;
  color: ${darkGrey};
`



// WEBPACK FOOTER //
// ./src/app/modules/EditUserDataForm/styles.js